module.exports = __webpack_public_path__ + "static/media/location-gray-2.7c98b797.svg";